<section class="py-16 bg-dark">
  <div class="container mx-auto px-4">
    <div class="max-w-6xl mx-auto text-center">
      <h2 class="text-4xl md:text-5xl font-bold mb-4 text-light">Veilig, Beveiligd en Compliant</h2>
      <p class="text-lg md:text-xl mb-12 text-gray-400">
        Jouw veiligheid staat voorop. Alle systemen voldoen aan Nederlands kansspel regelgeving
      </p>

      <!-- Feature Boxes -->
      <div class="grid md:grid-cols-2 gap-8 mb-16">
        <!-- Left Box: Security -->
        <div class="bg-dark-light rounded-lg p-8 border border-light/10">
          <div class="flex justify-center mb-6">
            <div class="w-16 h-16 bg-accent/20 rounded-full flex items-center justify-center">
              <svg class="w-8 h-8 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
              </svg>
            </div>
          </div>
          <h3 class="text-2xl font-bold mb-6 text-light">Toonaangevende Beveiliging</h3>
          <ul class="space-y-4 text-left">
            <li class="flex items-start">
              <span class="text-primary mr-3 mt-1">✓</span>
              <span class="text-gray-300">SSL-codering voor alle transacties</span>
            </li>
            <li class="flex items-start">
              <span class="text-primary mr-3 mt-1">✓</span>
              <span class="text-gray-300">Veilig identiteitsverificatieproces</span>
            </li>
            <li class="flex items-start">
              <span class="text-primary mr-3 mt-1">✓</span>
              <span class="text-gray-300">Regelmatige beveiligings audits en compliance controles</span>
            </li>
          </ul>
        </div>

        <!-- Right Box: Verified & Licensed -->
        <div class="bg-dark-light rounded-lg p-8 border border-light/10">
          <div class="flex justify-center mb-6">
            <div class="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center">
              <svg class="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
          </div>
          <h3 class="text-2xl font-bold mb-6 text-light">Volledig Geverifieerd & Gelicenseerd</h3>
          <ul class="space-y-4 text-left">
            <li class="flex items-start">
              <span class="text-accent mr-3 mt-1">✓</span>
              <span class="text-gray-300">Gelicenseerd door Nederlandse Kansspelautoriteit (KSA)</span>
            </li>
            <li class="flex items-start">
              <span class="text-accent mr-3 mt-1">✓</span>
              <span class="text-gray-300">KvK: 12345678 | Vergunning: NL-2024-001</span>
            </li>
            <li class="flex items-start">
              <span class="text-accent mr-3 mt-1">✓</span>
              <span class="text-gray-300">Gegarandeerde uitbetalingen en transparante activiteiten</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Statistics Section -->
      <div class="mt-16">
        <h3 class="text-2xl font-bold mb-8 text-light">Vertrouwd door Duizenden</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div class="text-center">
            <div class="text-5xl font-bold text-primary mb-2">50K+</div>
            <div class="text-gray-400">Actieve Spelers</div>
          </div>
          <div class="text-center">
            <div class="text-5xl font-bold text-accent mb-2">€10M+</div>
            <div class="text-gray-400">Uitgekeerde Prijzen</div>
          </div>
          <div class="text-center">
            <div class="text-5xl font-bold text-red-500 mb-2">100%</div>
            <div class="text-gray-400">Compliant & Geverifieerd</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

